import React, { useState } from 'react'
import { ROUTES } from '@sportninja/common/constants/app'
import { t } from '@sportninja/common/i18n'

import Page from '../../components/Page'
import TeamList from './TeamList'
import { connect } from 'react-redux'
import {
  getHockeySport,
  getSoccerSport,
} from '@sportninja/common/selectors/types'

const Teams = ({ hockeySport, soccerSport }) => {
  const [teamCount, setTeamCount] = useState('')
  const [favCount, setFavCount] = useState('')
  const [slug, setSlug] = useState('/users/me/teams')

  const pages = [
    {
      to: `${ROUTES.TEAMS.ROOT}/my`,
      text: `${t('common:team', { count: 2 })} ${
        teamCount ? `(${teamCount})` : ''
      }`,
      component: (
        <TeamList
          key='teams'
          slug={slug}
          setCount={setTeamCount}
          soccerSport={soccerSport}
          hockeySport={hockeySport}
          
        />
      ),
    },
    {
      to: `${ROUTES.TEAMS.FAVOURITES}`,
      text: `${t('common:favourite', { count: 2 })} ${
        favCount ? `(${favCount})` : ''
      }`,
      component: (
        <TeamList
          key='favs'
          slug='/favorites/teams'
          setCount={setFavCount}
          soccerSport={soccerSport}
          hockeySport={hockeySport}
        />
      ),
    },
  ]

  const BASE_ROUTE = ROUTES.TEAMS.ROOT

  return (
    <Page
      baseRoute={BASE_ROUTE}
      pages={pages}
      baseTitle={t('common:team', { count: 2 })}
      title={t('util:capitalize', {
        text: t('common:team', { count: 2 }),
      })}
    />
  )
}

const mapStateToProps = (state) => {
  return {
    hockeySportId: getHockeySport(state)?.id,
    soccerSportId: getSoccerSport(state)?.id,
    hockeySport: getHockeySport(state),
    soccerSport: getSoccerSport(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Teams)
